/**
 * @description: 判断是否是客户端, node环境下无window
 */
export const isClient = () => {
  try {
    window.___is__client = true;
    return true;
  } catch (error) {
    return false;
  }
};

/**
 * @description: 判断是否是客户端, 雅典娜预览的时候存在外部访问次项目的场景
 */
export const isDebug = () => {
  try {
    return (
      window.location.href.includes("athenaPreview") || window.location.href.includes("is____debug")
    );
  } catch (error) {
    return false;
  }
};

/**
 * @description  是否是233环境
 * isClient 是用于判断是不是本地打包，打包的时候默认走 233 环境
 */
export const isEnv233 = () => {
  if (!isClient()) {
    return true;
  }
  return navigator.userAgent.includes("MetaApp");
};

/**
 * @description  ?
 * isClient 是用于判断是不是本地打包，打包的时候默认走 233 环境
 */
export const isEnvModal = () => {
  if (!isClient()) {
    return true;
  }
  return navigator.userAgent.includes("meta-pay-sdk");
};

/**
 * 判断是不是 派对 环境
 * isClient 是用于判断是不是本地打包，打包的时候默认走 233 环境
 * map-mobile-pt 是派对包的userAgent变量
 */
export const isEnvPt = () => {
  if (!isClient()) {
    return true;
  }

  if (navigator.userAgent.includes("map-mobile-pt")) {
    return true;
  }
  return false;
};
